import React from "react";
import Chips from "../../Chips";

import Nnary from "@/modules/Nnary";
import { betGroupProp, getWinClassName } from "@/modules/commonMobile";
import nth0 from "@/modules/nth0";
import zeroFill from "@/modules/zeroFill";
import { assetImg } from "@/modules/moduleImporter";

import { IProps, BilliardsWinType } from ".";

export default class M13Portrait extends React.Component<IProps> {
    render() {
		const win: BilliardsWinType = this.props.win;

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const portraitRows = [
			["Small", "Big"],
			["Odd", "Even"]
		];

		const portraitPrizes = [
			["1:1", "1:1"],
			["1:0.95", "1:0.95"]
		];

		const portraitWins: boolean[][] = [
			[win && (win.win <= 7 && win.win > 0), win && (win.win >= 9)],
			[win && !(win.type % 2), win && !!(win.type % 2)]
		];

        return (
                <div className="sl-table m13-portrait">
					<div className="row">
						{
							portraitRows.map((row, rowIdx) =>
								row.map((cell, cellIdx) =>
									<div key={"m13_portrait_" + rowIdx + "_" + cellIdx}
										className={"sl-bet col-xs-6 sl-green-old" +
											getWinClassName(portraitWins[rowIdx][cellIdx])}

										{...betGroupProp(this, cell, "n50")}

										onClick={this.props.insertBet}>
										
										{this.props.langdata["txt_" + cell.toLowerCase()]}
										<div className="bet-type">
											{ portraitPrizes[rowIdx][cellIdx] }
										</div>
										<Chips {...commonChipProps} betKey={cell + "+n50"} />
									</div>
								)
							)
						}
					</div>

					{
						Nnary(0, 4).map(num => {
							const nth = nth0(num);
							const betKey = zeroFill(num + 1, 2) + "," +
									zeroFill(num + 6, 2) + "," +
									(num + 11);
							return (
								<div
									className={"sl-bet col-xs-2 m13-taller sl-green-old" + (win && (win.win - 1) % 5 === num ? " sl-yellow-alternating" : "")}
									key={`m13_${betKey}+n3`}
									{...{
										bet: betKey,
										pcode: this.props.pcode,
										group: "n3"
									}}
									onClick={this.props.insertBet}>
									{nth}
									<div className="bet-type">1:3.6</div>
									<Chips {...commonChipProps} betKey={betKey + "+n3"} />
								</div>
							);
						})
					}

					{
						[
							["01", "02", "03", "04", "05"],
							["06", "07", "08", "09", "10"],
							["11", "12", "13", "14", "15"]].map((group, idx) =>
								<div key={`m13_row${idx}`} className="row">
									{
										[
											...group.map(num =>
												<div className={"sl-bet col-xs-2 m13-taller sl-green-old" +
														(win && (win.win === Number(num)) ? " sl-yellow-alternating" : "")}
													key={`m13${num}+n`}
													{...{
														bet: num,
														pcode: this.props.pcode,
														group: "n"
													}}
													onClick={this.props.insertBet}>
													{assetImg("m13", Number(num) + "")}
													<div className="bet-type">1:13</div>
													<Chips {...commonChipProps} betKey={num + "+n"} />
												</div>
											),
											<div className={"sl-bet col-xs-2 m13-taller sl-green-old" + (win && group.indexOf(zeroFill(win.win, 2)) >= 0 ? " sl-yellow-alternating" : "")}
												key={`m13right${idx}`}
												{...betGroupProp(this, group.join(","), "n5")}
												onClick={this.props.insertBet}>
												{this.props.langdata["txt_2_to_1"]}
												<div className="bet-type">1:1.75</div>
												<Chips {...commonChipProps} betKey={group.join(",") + "+n5"} />
											</div>
										]
									}
								</div>
							)
					}
				</div>
        );
    }
}
